module.exports = __webpack_public_path__ + "img/loader.42b9bde2.svg";